import axios from "./api";

// 防沉迷认证
export const bindIdentity = data => {
  return axios({
    url: "/v2/user/bindidcard",
    method: "post",
    loading: true,
    data
  });
};

// 验证手机
export const checkPhone = data => {
  return axios({
    url: "/v2/user/checksms",
    method: "post",
    loading: true,
    data
  });
};

// 绑定手机
export const bindPhone = data => {
  return axios({
    url: "/v2/user/bindphone",
    method: "post",
    loading: true,
    data
  });
};

// 找回密码
export const modifypassword = data => {
  return axios({
    url: "/v2/user/modifypassword",
    method: "post",
    loading: true,
    data
  });
};

// 修改绑定手机
export const modifyPhone = data => {
  return axios({
    url: "/v2/user/modifyphone",
    method: "post",
    loading: true,
    data
  });
};
